import React from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./SwiperStyles.css";

// import required modules
import { Navigation } from "swiper/modules";
import ProductItem from "../../Main/ListOfProducts/ProductItem";

const SwiperListOfProductsByCategoryLayout = ({
  data,
  navColor,
}: {
  data: any;
  navColor: string;
}) => {
  const breakpoints = {
    300: { slidesPerView: 1.3 },
    350: { slidesPerView: 1.4 },
    380: { slidesPerView: 1.6 },
    420: { slidesPerView: 1.7 },
    480: { slidesPerView: 1.8 },
    530: { slidesPerView: 2.2 },
    600: { slidesPerView: 2.2 },
    768: { slidesPerView: 3.4 },
    900: { slidesPerView: 3.8 },
    1024: { slidesPerView: 4.2 },
    1124: { slidesPerView: 4.8 },
    1280: { slidesPerView: 5.2 },
    1360: { slidesPerView: 5.8 },
  };
  // console.log("navColor", navColor);

  return (
    <div
      style={
        {
          // Set navigation arrow color dynamically
          "--swiper-navigation-color": navColor,
        } as React.CSSProperties
      }
    >
      <Swiper
        breakpoints={breakpoints}
        slidesPerView={1.1}
        spaceBetween={10}
        // navigation={true}
        freeMode={true}
        pagination={{
          //   type: "fraction",
          clickable: true,
        }}
        // modules={[FreeMode, Pagination]}
        modules={[Navigation]}
        className="mySwiper"
      >
        {data.map((product: any) => (
          <SwiperSlide>
            <ProductItem
              key={product.id}
              items={product}
              colorCode={product.colorCode || navColor}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default SwiperListOfProductsByCategoryLayout;
